import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface RescheduleDialogProps {
    open: boolean;
    onCancel: () => void;
    onReschedule: (instant: boolean) => void;
    translations: {
        title: string;
        question: string;
        cancel: string;
        asPlanned: string;
        instant: string;
    };
}

const RescheduleDialog: React.FC<RescheduleDialogProps> = ({
    open,
    onCancel,
    onReschedule,
    translations
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="reschedule-dialog-title"
            aria-describedby="reschedule-dialog-description"
        >
            <DialogTitle id="reschedule-dialog-title">
                {translations.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="reschedule-dialog-description">
                    {translations.question}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {translations.cancel}
                </Button>
                <Button onClick={() => onReschedule(false)} color="primary" variant="outlined">
                    {translations.asPlanned}
                </Button>
                <Button onClick={() => onReschedule(true)} color="primary" variant="contained">
                    {translations.instant}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RescheduleDialog;

